import { connect } from "react-redux"
// @ts-expect-error: Flow to TS migration.
import type { Connector } from "react-redux"
import HeaderDataSideEffects from "@kiwicom/frontend-common/browser/components/HeaderDataSideEffects"
import type { Props } from "@kiwicom/frontend-common/browser/components/HeaderDataSideEffects"
import * as selectors from "@kiwicom/frontend-common/browser/headerDataSelectors"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const connector: Connector<Record<any, any>, Props> = connect((state) => ({
  // @ts-expect-error: Flow to TS migration.
  title: selectors.getTitle(state),
  // @ts-expect-error: Flow to TS migration.
  keywords: selectors.getKeywords(state),
  // @ts-expect-error: Flow to TS migration.
  description: selectors.getDescription(state),
}))

export default connector(HeaderDataSideEffects)
